import React from "react";
import { connect, ConnectedProps } from "react-redux";
import NewsIcon from "./NewsIcon";
import { ActiveSpell } from "../../../lib/types";
import {
  formatNumber,
  formatNumberForceSigned
} from "../../../lib/commonFunctions";

const mapStateToProps = (state: any) => ({
  govId: state.governorate.id,
  allQuestsFinished: state.governorate.allQuestsFinished,
  hasFinishedQuest: state.governorate.hasFinishedQuest,
  tutorialFinished: state.governorate.tutorialFinished,
  canDoLabyrinth: state.governorate.canDoLabyrinth,
  labyrinthAttemptLimit: state.governorate.labyrinthAttemptLimit,
  labyrinthAttempt: state.governorate.labyrinthAttempt,
  turnNews: state.governorate.turnNews,
  famine: state.governorate.famine,
  bankruptcy: state.governorate.bankruptcy,
  readyToAttack: state.governorate.readyToAttack,
  armyFormation: state.governorate.armyFormation,
  war: state.governorate.war,
  preWarPopulation: state.governorate.preWarPopulation,
  postWarInformation: state.governorate.postWarInformation,
  population: state.governorate.population.total,
  populationBalance: state.governorate.resourceBalances.populationGrowth,
  alliance: state.governorate.alliance,
  opponent: state.governorate.opponent,
  buffs: state.governorate.spells.active.filter((spell: ActiveSpell) => spell.spell.buff),
  debuffs: state.governorate.spells.active.filter((spell: ActiveSpell) => spell.spell.debuff),
  castSpells: state.governorate.spells.cast,
  magicClosed: state.governorate.magicClosed,
  magicDisruption: state.governorate.magicDisruption,
});

const connector = connect(mapStateToProps);

const TurnNews = ({
  govId,
  allQuestsFinished,
  hasFinishedQuest,
  tutorialFinished,
  canDoLabyrinth,
  labyrinthAttemptLimit,
  labyrinthAttempt,
  turnNews,
  famine,
  bankruptcy,
  war,
  postWarInformation,
  preWarPopulation,
  population,
  populationBalance,
  alliance,
  opponent,
  buffs,
  debuffs,
  castSpells,
  magicClosed,
  magicDisruption
}: ConnectedProps<typeof connector>) => (
  <div className="news news-square">
    {!allQuestsFinished || tutorialFinished
      ? <NewsIcon
        classes={`positive ${hasFinishedQuest ? " minus" : ""}`}
        tooltipOptions={{
          name: "QuestList",
          dynamic: true
        }}
        icon={"politika"}
        click={true}
      /> : null
    }

    {war && <NewsIcon
      classes={"negative"}
      icon={"armada"}
      hover={true}
      tooltipOptions={{
        name: "Battle News",
        title: "Battle news",
        content: `<div>
          Your alliance is at war with alliance <em>${opponent && opponent.name}</em>
            </div>
            <div>
                Progress: ${war.duration}/5<br />
                ${war.duration
          ? `You have ${war.countResult} last count<br />`
          : "Awaiting first count<br />"}
                Your war points: ${alliance.warPoints}<br />
                Opponent's war points: ${opponent.warPoints}<br />
                Actual points of power score: ${(10 + 3 * alliance.warPoints)}<br />
            </div>`,
        static: true
      }}
    />
    }

    {alliance && alliance.warApplication && <NewsIcon
      classes={"gold"}
      icon={"armada"}
      hover={true}
      tooltipOptions={{
        name: "War application",
        title: "War application",
        content: `<div>Your alliance applied for war, get ready for the fight!</div>
            <div>During the count matching system will try to find you the opponent.</div>`,
        static: true
      }}
    />
    }

    {alliance && postWarInformation && !!alliance.warResult && <NewsIcon
      classes={"positive"}
      icon={"armada"}
      hover={true}
      tooltipOptions={{
        name: "War finished",
        title: "War finished",
        content: `<div>
                Your alliance has finished the war last count.
            </div>
            <div>
                You have earned: <em>${alliance.warResult.myPowerGain}</em> <i class="icon icon-pozemky align-sub"></i><br />
                Governorate rating gain: <em>${alliance.warResult.ratings[govId] || "NA"}</em><br />
                You have ${alliance.warResult.myWarPoints < alliance.warResult.opponentWarPoints
          ? "lost" : (alliance.warResult.myWarPoints > alliance.warResult.opponentWarPoints ? "won" : "drew")} the war<br />
                Your final war points: <em>${alliance.warResult.myWarPoints}</em><br />
                Opponents final war points: <em>${alliance.warResult.opponentWarPoints}</em><br />
            </div>
            <div>
                Governorate has happiness boost for next three counts. <br />
                ${preWarPopulation > population ? `Governorate has +50 to pop growth until pre-war population (<em>${preWarPopulation}</em>).` : ""}
            </div>`,
        static: true
      }}
    />
    }

    {turnNews.map((news: any) => <NewsIcon
      classes={news.class}
      icon={news.icon}
      hover={true}
      tooltipOptions={{
        name: news.title,
        title: news.title,
        content: news.content,
        static: true
      }}
    />)}

    {!!buffs.length && <NewsIcon
      classes={"positive"}
      icon={"kouzlo-poz"}
      hover={true}
      tooltipOptions={{
        name: "Active buffs",
        title: "Active buffs",
        content: buffs.map((buff: ActiveSpell) => `<div>
            <span>${buff.spell.name}</span>: <span>
            ${buff.effectDescription} (${buff.power} turns)</span>
          </div>`).join(""),
        static: true
      }}
    />}

    {!!debuffs.length && <NewsIcon
      classes={"negative"}
      icon={"kouzlo-neg"}
      hover={true}
      tooltipOptions={{
        name: "Active debuffs",
        title: "Active debuffs",
        content: debuffs.map((debuff: ActiveSpell) => `<div>
            <span>${debuff.spell.name}</span>: <span>
            ${debuff.effectDescription} (${debuff.power} turns)</span>
          </div>`).join(""),
        static: true
      }}
    />}

    {populationBalance.revolt || magicDisruption
      ? <NewsIcon
        classes={"negative"}
        icon={"zlodeji"}
        hover={true}
        tooltipOptions={{
          name: "Thief actions",
          title: "Thief actions",
          content: `${populationBalance.revolt ? `<div>
            <span>Revolt: Pop growth ${formatNumber(populationBalance.revolt)}</span>
          </div>` : ""}
          ${magicDisruption ? `<div>
            <span>Disruption: Spell price ${formatNumberForceSigned(magicDisruption)}%</span>
          </div>` : ""}`,
          static: true
        }}
      /> : <></>}

    {famine
      ? <NewsIcon
        classes={"negative"}
        icon={"jidlo"}
        hover={true}
        tooltipOptions={{
          name: "Food shortage",
          title: "Food shortage",
          content: "Your people are suffering from food shortage and are going to die in droves with next turn!",
          static: true
        }}
      /> : <></>}

    {bankruptcy
      ? <NewsIcon
        classes={"negative"}
        icon={"zlato"}
        hover={true}
        tooltipOptions={{
          name: "Bankruptcy!!!",
          title: "Bankruptcy!!!",
          content: "Your governorate suffers from gold shortage! Production and progress is decreased!",
          static: true
        }}
      /> : <></>}

    {canDoLabyrinth && labyrinthAttempt < labyrinthAttemptLimit
      ? <NewsIcon
        classes={"gold"}
        icon={"labyrint"}
        hover={true}
        tooltipOptions={{
          name: "Available labyrinth",
          title: "Available labyrinth",
          content: "There are labyrinth attempts available.",
          static: true
        }}
      /> : <></>}

    {/* {readyToAttack && !getGovernorateFormationPositionName(govId, armyFormation) */}
    {/*  ? <NewsIcon */}
    {/*    classes={"gold"} */}
    {/*    icon={"imperator"} */}
    {/*    hover={true} */}
    {/*    tooltipOptions={{ */}
    {/*      name: "Idle army", */}
    {/*      title: "Idle army", */}
    {/*      content: "Your army is not sent to battle. Place it to banner to uset ist power.", */}
    {/*      static: true */}
    {/*    }} */}
    {/*  /> : <></>} */}

    {castSpells?.length && !magicClosed
      ? <NewsIcon
        classes={"gold"}
        icon={"magie"}
        hover={true}
        tooltipOptions={{
          name: "Magic not closed",
          title: "Magic not closed",
          content: "You have spells planned for the count, but magic is not closed.",
          static: true
        }}
      /> : <></>}
  </div>
)

export default connector(TurnNews);
